import type { HomeFeed } from '../schema-copy/api-schema';

export type HomeCategorySort = 'name' | 'lastPost' | 'frequency';

export const HOME_CATEGORY_SORTS: { id: HomeCategorySort; text: string }[] = [
  { id: 'name', text: 'Name' },
  { id: 'lastPost', text: 'Last update' },
  { id: 'frequency', text: 'Post frequency' },
];

/** Sorted copy of a category's feeds: by name (A→Z), last update (newest first) or post frequency
 *  (most active first). Feeds without the value go last, in name order. */
export function sortHomeFeeds(feeds: HomeFeed[], sort: HomeCategorySort): HomeFeed[] {
  const byName = (a: HomeFeed, b: HomeFeed) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
  const value = (f: HomeFeed) => sort == 'lastPost' ? f.lastPostMs : sort == 'frequency' ? f.postFrequency : undefined;
  return [...feeds].sort((a, b) => {
    const va = value(a), vb = value(b);
    if (va != vb) {
      if (va == undefined) return 1;
      if (vb == undefined) return -1;
      return vb - va;
    }
    return byName(a, b);
  });
}
